function OwnerFilterSkeleton() {
  return (
    <div className="flex md:flex-row z-40 mr-3 ml-0 w-full md:ml-4 animate-pulse">
      <div className="animate-pulse mt-1">
        <div className="h-4 w-16 bg-gray-300 rounded mb-2"></div>
        <div className="h-[38px] w-48 bg-gray-300 rounded"></div>
      </div>
    </div>
  );
}

export default OwnerFilterSkeleton;
